import stringHash from 'string-hash';
import isMobile from 'is-mobile';
import classNames from 'classnames';
import React, { Component, PropTypes } from 'react';

let didInitialKarmaScriptLoad = false;

/**
 * Class representing an ad unit on the website.
 */
class KarmaAdvertisementUnit extends Component {
  static propTypes = {
    className: PropTypes.string,
    karmaId: PropTypes.string.isRequired,
    karmaDataTier: PropTypes.string.isRequired,
    karmaType: PropTypes.string,
    initialScriptSrc: PropTypes.string,
    finalScriptSrc: PropTypes.string
  };

  static contextTypes = {
    flux: PropTypes.object.isRequired
  }

  static defaultProps = {
    karmaType: '',
    initialScriptSrc: 'https://karma.mdpcdn.com/service/js/karma.header.js',
    finalScriptSrc: 'https://karma.mdpcdn.com/service/js-min/karma.footer.js'
  }

  componentWillMount() {
    const { initialScriptSrc, finalScriptSrc, karmaType } = this.props;

    if (!didInitialKarmaScriptLoad) {
      if (typeof window !== 'undefined') {
        const target = document.getElementsByTagName('head')[0];
        const initialScriptNode = document.createElement('script');
        initialScriptNode.setAttribute('type', 'text/javascript');
        initialScriptNode.src = initialScriptSrc;
        target.appendChild(initialScriptNode);
        didInitialKarmaScriptLoad = true;

        window.addEventListener('load', () => {
          this.loadFinalScript(window, finalScriptSrc, karmaType);
        });
      }
    }
  }

  loadFinalScript(window, finalScriptSrc, karmaType) {
    const isMobileDevice = isMobile();
    const { flux } = this.context;
    const contentClassification = flux.getStore('ContentClassification').getState().contentClassification;
    const uniqueUrlId = stringHash(window.location.pathname);

    let query = '';
    if (window.location.search) {
      // getting query for karma footer tag
      const queryLocation = window.location.search;
      query = queryLocation.split('qu=').pop();
      query = query.slice(0, query.lastIndexOf('&'));
    }

    const karmaAdData = {
        mobileAds: isMobileDevice,

        unitValues: {
            channel: contentClassification
        },

        pageTargetingValues: {
            id: uniqueUrlId,   // hashed url  - path
            type: karmaType, // this needs to get pulled in from KarmaAdvertisementUnit.js
            search: query
        }
    };

    window.adService = karmaAdData;

    const finalScriptNode = document.createElement('script');
    finalScriptNode.src = finalScriptSrc;
    finalScriptNode.async = true;
    finalScriptNode.setAttribute('type', 'text/javascript');
    const targetScriptNode = document.getElementsByTagName('script')[0];
    targetScriptNode.parentNode.insertBefore(finalScriptNode, targetScriptNode);
  }

  render() {
    const { karmaId, karmaDataTier, className: classNameProp } = this.props;
    const className = classNames('KarmaAdvertisementUnit', 'AdvertisementUnit', classNameProp);

    return (
      <div id={karmaId} className={className} data-tier={karmaDataTier} />
    );
  }

}

export default KarmaAdvertisementUnit;



// WEBPACK FOOTER //
// ./app/components/KarmaAdvertisementUnit.js